;(function () {
	let swiper
	const testimonials = () => {
		$('.testimonials-section').each(function () {
			const id = $(this).attr('id')
			const box = $(this).find('.testimonials')
			const autoplay = box.data('autoplay')
			const stopAutoplay = box.data('stop-autoplay')
			const delay = box.data('delay') * 1000
			const blockCount = box.data('block-count')

			let autoplayParm = {}
			if (autoplay) {
				autoplayParm = {
					autoplay: {
						delay: delay,
						pauseOnMouseEnter: stopAutoplay,
						disableOnInteraction: false,
					},
				}
			}

			let paginationType = determinePaginationType()

			let swiperParms = {
				speed: box.data('speed') * 1000,
				slidesPerView: 1,
				// loop:false so Swiper doesn't lock with only 3 slides —
				// user reported not being able to swipe at all, which happens
				// when loop:true + small slide count + fractional slidesPerView
				// triggers Swiper's "isLocked" flag on some breakpoints.
				loop: false,
				spaceBetween: 16,
				allowTouchMove: true,
				resistanceRatio: 0.35,
				breakpoints: {
					576: {
						slidesPerView: 1.3,
						spaceBetween: 40,
					},
					750: {
						slidesPerView: 1.9,
						spaceBetween: 60,
					},
				},
				autoHeight: false,
				calculateHeight: false,
				keyboard: true,
				navigation: {
					nextEl: `#${id} .swiper-button-next`,
					prevEl: `#${id} .swiper-button-prev`,
				},
				pagination: {
					el: `#${id} .swiper-pagination`,
					clickable: true,
					// Bullet pagination (same style as Bestsellers).
					type: 'bullets',
					dynamicBullets: false,
				},
				on: {
					slideChangeTransitionEnd: function () {
						if (autoplay) {
							$('.swiper-slide-active').find('#shape').addClass('start-spin')
							$('.swiper-slide-active').find('#shape1').addClass('start-spin')
						}
					},
				},
				...autoplayParm,
			}

			if (swiper) {
				swiper.destroy()
			}

			if (blockCount > 1) {
				swiper = new Swiper(`#${id} .swiper`, swiperParms)
			}

			if (autoplay && stopAutoplay) {
				document
					.querySelector(`#${id} .testimonials__swiper`)
					.addEventListener('mouseenter', function () {
						$('.swiper-slide-active').find('#shape').removeClass('start-spin')
					})
				document
					.querySelector(`#${id} .testimonials__swiper`)
					.addEventListener('mouseleave', function () {
						$('.swiper-slide-active').find('#shape').addClass('start-spin')
					})
			}
		})
	}

	function determinePaginationType() {
		// Unified bullet pagination on all viewports (matches Bestsellers style)
		return 'bullets'
	}

	/**
	 * "Read all reviews" smooth-scroll handler (product pages only).
	 *
	 * Finds the first reviews widget on the page (Okendo / Judge.me / native
	 * fallback) and scrolls to it. We try multiple selectors because the
	 * shop may swap review providers without us editing this file.
	 */
	const REVIEWS_SELECTORS = [
		'#reviews',
		'[data-oke-widget-id]',
		'[data-oke-reviews-widget]',
		'.okeReviews-reviewsWidget',
		'.okeReviews',
		'.jdgm-rev-widg',
		'#shopify-product-reviews',
		'#judgeme_product_reviews',
	].join(', ')

	function findReviewsAnchor() {
		// Prefer an in-DOM widget; fall back to its containing Shopify section
		// so the user lands at the section header rather than mid-list.
		const widget = document.querySelector(REVIEWS_SELECTORS)
		if (!widget) return null
		return widget.closest('.shopify-section') || widget
	}

	function bindReadAllReviews() {
		document.querySelectorAll('[data-scroll-to-reviews]').forEach((btn) => {
			if (btn.dataset.scrollBound === '1') return
			btn.dataset.scrollBound = '1'
			btn.addEventListener('click', function (e) {
				const target = findReviewsAnchor()
				if (!target) return // let default href="#reviews" behavior run
				e.preventDefault()
				target.scrollIntoView({ behavior: 'smooth', block: 'start' })
				// Update URL hash without jumping (smooth scroll handles position).
				if (history.replaceState) history.replaceState(null, '', '#reviews')
			})
		})
	}

	document.addEventListener('DOMContentLoaded', function () {
		testimonials()
		bindReadAllReviews()
		document.addEventListener('shopify:section:load', function () {
			testimonials()
			bindReadAllReviews()
		})
		// No re-init on resize needed any more — pagination type is constant,
		// and Swiper handles breakpoint-based slidesPerView changes on its own.
	})
})()
